export default "__VITE_ASSET__C1uEI5v4__"